import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { getProxiesWord } from "./GetProxiesWord";

interface DeactivateProxiesDialogProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeactivateProxiesDialog(props: DeactivateProxiesDialogProps) {
  const { open, count, onClose, onConfirm } = props;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Удаление прокси</DialogTitle>
      <DialogContent>
        <Typography>
          Удалить {count} {getProxiesWord(count)}? Удалённые прокси
          будут исключены из использования.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
